<template lang="pug">
  div
    template(v-for="description in description[locale]")
      p {{ description }}
    ValidationObserver(v-slot="{ passes }")
      form(@submit.stop.prevent="passes(onSubmit)" novalidate)
        .row
          .col-sm-6

            ValidationProvider(
              :name="$t('petType')"
              rules="required"
              v-slot="{ errors }")
              .pf-form-group
                label.pf-label {{ $t('petType') }}
                .inline-radio
                  .pf-radio-group.pf-basic-radio
                    input#customRadioInline1(
                      v-model="personalInfos.petType"
                      type="radio"
                      name="customRadioInline1"
                      value="0")
                    label(for='customRadioInline1') {{ $t('dog') }}
                  .pf-radio-group.pf-basic-radio
                    input#customRadioInline2(
                      v-model="personalInfos.petType"
                      type="radio"
                      name="customRadioInline2"
                      value="1")
                    label(for='customRadioInline2') {{ $t('cat') }}
              .pf-error {{ errors[0] }}
            .pf-form-group
              label.pf-label {{ $t('deductible') }}
              input.pf-input(
                v-model="personalInfos.deductible"
                type="number")
            .pf-form-group
              .pf-other-insurance-selections
                .pf-checkbox-group
                  input#hereditarySelection(
                    v-model="personalInfos.hereditaryDiseases"
                    type="checkbox")
                  label(for="hereditarySelection") {{ $t('hereditaryDiseases') }}
          .col-sm-6
            ValidationProvider(
              :name="$t('dateOfBirth')"
              rules="required"
              v-slot="{ errors }")
              .pf-form-group
                label.pf-label {{ $t('dateOfBirth') }}
                input.pf-input(
                  v-model="personalInfos.birthDate"
                  type='date')
                .pf-error {{ errors[0] }}
            .pf-form-group
              label.pf-label {{ $t('cover') }}
              input.pf-input(
                v-model="personalInfos.insuredSum"
                type="text")
            ValidationProvider(
              :name="$t('startOfInsurance')"
              rules="required"
              v-slot="{ errors }")
              .pf-form-group
                label.pf-label {{ $t('startOfInsurance') }}
                input.pf-input(
                  v-model="personalInfos.startOfInsurance"
                  type='date')
                .pf-error {{ errors[0] }}
        .row
          .col-sm-6
          .col-sm-6
            button(type="submit").pf-button {{ $t('continueToOfferSelection') }}
</template>

<script>
import moment from 'moment';
import {
  axiosGetData,
} from '@/support/utils';
import ApiService from '../../services/api.service';

export default {
  name: 'StepOne',
  data() {
    return {
      personalInfos: {
        birthDate: '',
        petType: '',
        age: '',
        deductible: '',
        insuredSum: '',
        startOfInsurance: '',
        hereditaryDiseases: false,
      },
      description: window.pet.description,
    };
  },
  created() {
    this.$wait.start('Insurance Companies');
    ApiService.get('InsuranceCompanyTravel/GetAll')
      .then(axiosGetData)
      .then((response) => {
        const companiesBelowZero = response.filter(
          (company) => company.groupId < 0,
        );
        const companiesAboveZero = response.filter(
          (company) => company.groupId > 0,
        ).sort((a, b) => a.shortName.localeCompare(b.shortName));
        this.insuranceCompanies = [
          ...companiesBelowZero,
          ...companiesAboveZero,
        ];
        this.$wait.end('Insurance Companies');
      });
  },
  methods: {
    onSubmit() {
      this.$store.dispatch('setUserInfos', this.personalInfos);
      this.goToSpecificStep(2);
    },
  },
  watch: {
    'personalInfos.birthDate': function (newVal) {
      const age = moment().year() - moment(newVal, 'YYYY-MM-DD').year();
      this.$set(this.personalInfos, 'age', age);
    },
    'personalInfos.region': function (newVal) {
      this.$set(this.personalInfos, 'regionType', newVal ? '1' : '0');
    },
  },
};

</script>
